import React from "react";
import { Button, Modal } from "semantic-ui-react";
import PeriodFilters from "../Compliance/filters/PeriodFilters";
import useEventDetailsGrid from "../../hooks/useEventDetailsGrid";

const DateRangeModal = () => {
  const { showDateRangeModal, onRefresh, setViewData } = useEventDetailsGrid();
  const onClose = () => setViewData({ showDateRangeModal: false });

  return (
    <Modal open={showDateRangeModal} onClose={onClose} closeIcon size="tiny">
      <Modal.Header>Select Date Range</Modal.Header>
      <Modal.Content className="flex-row-center">
        <PeriodFilters />
      </Modal.Content>
      <Modal.Actions>
        <Button floated="left" onClick={onClose}>
          Cancel
        </Button>
        <Button
          positive
          onClick={() => {
            onClose();
            onRefresh();
          }}
        >
          Submit
        </Button>
      </Modal.Actions>
    </Modal>
  );
};

export default DateRangeModal;
